import loadingImg from '../../assets/images/loading-green.svg';
import React, { Component } from 'react';
import './confirmacaoEmailAlteracao.scss';



class ConfirmacaoEmailAlteracao extends Component {


  componentDidMount() {
    let {
      match,
      history,
      checkConfirmationHashAction
    } = this.props;

    if (!match.params.id)
      history.push('/vamosComecar');
    else
      checkConfirmationHashAction(match.params.id);
      
    setTimeout(() => {
      window.localStorage.clear();
      window.location.href = "https://btcorretora.com.br/"
    }, 15000)
  }

  render() {
    // let {
    //   match,
    //   setLoadingValue,
    //   confirmacaoEmail,
    //   checkConfirmationHashAction,
    // } = this.props;

    let {
      loading,
      //isError
    } = this.props.confirmacaoEmailAlteracao;

    if (loading) {
      return (
        <div className="loadingScreen">
          <img className="loadingCircle" src={loadingImg} alt="loading" />
        </div>
      )
    }
    else {
      return (
        <div className="confirmacaoEmail">
          <div className="col">
            <i className={`successIcon fa ${this.props.confirmacaoEmailAlteracao.screenInfo.icon}`}></i>
          </div>
          <div className="container">
            <div className="col">
              <h1 className="title">{this.props.confirmacaoEmailAlteracao.screenInfo.title}</h1>
              <span className="message">{this.props.confirmacaoEmailAlteracao.screenInfo.discription}</span>
            </div>
          </div>
        </div>)
    }
  }
}

export default ConfirmacaoEmailAlteracao;